module.exports = __webpack_public_path__ + "img/prev.c3375cb3.png";